export enum JobHistoryStatus
{
    STARTED = 'STARTED',
    RUNNING = 'RUNNING',
    FAILED = 'FAILED',
    FINISHED = 'FINISHED',
    CANCELED = 'CANCELED',
    TERMINATED = 'TERMINATED'
}
